import { Form } from 'react-bootstrap';

import useIsMobile from '../../../utils/useIsMobile';
import { SALES_REPORT_PAGE_SIZES, formatCount } from '../../../utils/salesReportUtils';

const pageWindow = (page, pages, size) => {
    const half = Math.floor(size / 2);
    let start = Math.max(1, page - half);
    let end = Math.min(pages, start + size - 1);
    start = Math.max(1, end - size + 1);
    const items = [];
    for (let number = start; number <= end; number += 1) {
        items.push(number);
    }
    return items;
};

const SalesReportPager = ({ page, pages, total, pageSize, onPage, onPageSize }) => {
    const isMobile = useIsMobile();

    if (!total) {
        return null;
    }

    const safePages = Math.max(pages || 1, 1);
    const from = total ? (page - 1) * pageSize + 1 : 0;
    const to = Math.min(page * pageSize, total);
    const numbers = pageWindow(page, safePages, isMobile ? 3 : 5);

    return (
        <div className="sr-pager">
            <p className="sr-hint mb-0">
                {from}–{to} de {formatCount(total)}
            </p>
            <div className="sr-pages" role="navigation" aria-label="Paginación">
                <button type="button" className="sr-page-btn" onClick={() => onPage(page - 1)} disabled={page <= 1}>
                    Anterior
                </button>
                {numbers.map((number) => (
                    <button
                        key={number}
                        type="button"
                        className={`sr-page-btn${number === page ? ' is-active' : ''}`}
                        onClick={() => onPage(number)}
                        aria-current={number === page ? 'page' : undefined}
                    >
                        {number}
                    </button>
                ))}
                <button
                    type="button"
                    className="sr-page-btn"
                    onClick={() => onPage(page + 1)}
                    disabled={page >= safePages}
                >
                    Siguiente
                </button>
            </div>
            <Form.Group className="sr-field mb-0">
                <Form.Label column={false} className="mb-1">Por página</Form.Label>
                <Form.Select
                    value={pageSize}
                    aria-label="Resultados por página"
                    onChange={(event) => onPageSize(Number(event.target.value))}
                >
                    {SALES_REPORT_PAGE_SIZES.map((size) => (
                        <option key={size} value={size}>
                            {size}
                        </option>
                    ))}
                </Form.Select>
            </Form.Group>
        </div>
    );
};

export default SalesReportPager;
